import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PaymentService } from 'src/app/common/services/payment.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { CROSS, ROI } from 'src/defaultImages.js';

@Component({
  selector: 'app-view-bill',
  templateUrl: './view-bill.component.html',
  styleUrls: ['./view-bill.component.css'],
})
export class ViewBillComponent implements OnInit {
  currency: string;
  images = {
    CROSS: CROSS,
    ROI: ROI,
  };
  billToPay: number = 0;
  billStatusText = {
    pending: {
      text: 'Pending',
      color: 'red',
      disabled: false,
    },
    bill_paid: {
      text: 'Bill Paid',
      color: 'green',
      disabled: true,
    },
  };
  billInfoArr = [];
  allChecked: boolean = false;
  paymentBody: any;
  reoccurChecked: boolean = true;
  constructor(
    private _modalService: NzModalService,
    private _payment: PaymentService,
    private _curr: CurrencyService,
    public _dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.currency = this._curr.getCurrency();
  }

  ngOnInit() {
    // Initialize the billInfoArr with checkbox state as unchecked
    this.billInfoArr = ((this.data || {}).dataArr || []).map((billInfo) => {
      return {
        ...billInfo,
        checked: false,
      };
    });
  }

  reoccurCheckHandler(event) {
    if ((event || {}).hasOwnProperty('checked')) {
      this.reoccurChecked = event.checked;
    }
  }
  async openReOccurHowWorks() {
    const { ReoccurKnowMoreComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/shared/shared modal/reoccur-know-more/reoccur-know-more.component'
    );
     this._modalService.create({
      nzClosable: false,
      nzContent: ReoccurKnowMoreComponent,
      nzBodyStyle: { padding: '20px' },
      nzStyle: { top: '45px' },
      nzFooter: null,
      nzWidth: 450,
      nzMaskClosable: false,
      nzComponentParams: {
        showRazorText: false,
      },
    });
  }
  // Handle the checkbox to update the billToPay amount
  updateAllBillChecked(e) {
    let billCalc = 0;
    this.billInfoArr.forEach((billInfo) => {
      if (!billInfo.disabled) {
        // Check if the checkbox is not disabled
        billInfo.checked = e;
        if (e) {
          billCalc += billInfo.bill;
        }
      }
    });

    if (!e) {
      billCalc = 0;
    }

    this.billToPay = billCalc;
  }

  // Handle individual outlet checkbox changes
  updateOutletChecked(e, data) {
    this.allChecked = (this.billInfoArr || []).every((billInfo) => (billInfo || {}).checked);
    if (e) {
      this.billToPay += (data || {}).bill;
    } else {
      this.billToPay -= (data || {}).bill;
    }
  }

  // Close the dialog
  close() {
    this._dialogRef.close({ data: '', success: 1, message: 'closed' });
  }

  // Pay the selected bills
  askForReocurrInfoandPay() {
    const selectedRestaurants = (this.billInfoArr || []).filter(
      (billInfo) => (billInfo || {}).checked
    );
    this.paymentBody = selectedRestaurants.map((billInfo) => {
      return {
        restaurant_id: (billInfo || {}).rest_id,
        amount: Math.abs((billInfo || {}).amount),
      };
    });
    this._payment.payNow(this.paymentBody,this.reoccurChecked);
  }

  isAtLeastOneItemChecked(): boolean {
    return this.billInfoArr.some((data) => data.checked);
  }
}
